import { useRoleStore, type Role } from './roleStore';
import { useSession } from './useSession';

/** The role the portal acts in. In a demo (the server's PORTAL_DEMO_ROLES) it is the "Viewing as" switcher's, with all
 * of that role's rights except user management; otherwise it is the signed-in account's own role and the switcher is
 * hidden. accountRole is the account's own, or the picked role until the session has loaded. */
export function useActingRole(): { role: Role; demo: boolean; accountRole: Role } {
  const picked = useRoleStore((s) => s.role);
  const account = useSession().data;
  const demo = account?.demoRoles ?? true;
  return { role: demo || !account ? picked : account.role, demo, accountRole: account?.role ?? picked };
}
